import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared';
import { Core2Config } from '../../shared';
import { PurchaseCreditNoteFileImportHelperContainerModel } from '../../../../../../models/aggregates/erp/purchase-credit-note-file-import/index';

@Injectable({
  providedIn: 'root'
})
export class PurchaseCreditNoteFileImportHelperService extends BaseApiTemplateService<PurchaseCreditNoteFileImportHelperContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'internal-purchase-credit-note/import-file-hdr/helper/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'internal-purchase-credit-note/import-file-hdr/helper/backoffice-ep';
    this.httpClient = http;
  }
}